import {Component, Input} from '@angular/core';

export type AlertType = 'error' | 'warning' | 'info' | 'success';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  @Input() message: string | null = null;
  @Input() type: AlertType = 'error';

  get icon(): string {
    switch (this.type) {
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      case 'error':
      default:
        return 'error_outline';
    }
  }
}
